<template>
    <BreadCrumb PageTitle="Importation des éléménts électriques d'un contrat" />
      <ImportationElement />
    </template>
    
    <script lang="ts">
      import { defineComponent } from "vue";
      import BreadCrumb from "../../components/Common/BreadCrumb.vue";  
      import ImportationElement from "@/components/Importation/ImportationElementElectrique.vue";
  
    
      export default defineComponent({
        name: "ImportationElementElectriquePage",
        components: {
            ImportationElement,
        },
      });
    </script>